import React, { Component } from "react";
import {
  Layout,
  Page,
  Card,
  Button,
  TextField,
  Stack,
  Spinner,
  ResourceList,
  TextStyle,
  Badge,
  Heading,
  ChoiceList,
  Select,
  Loading,
  Checkbox,
  List,
  Banner,
} from "@shopify/polaris";
import { API } from "aws-amplify";
import "rc-color-picker/assets/index.css";
import { presets } from "./../resources/Presets";
import ColorPicker from "rc-color-picker";
import HexRgb from "hex-rgb";
import FontPicker from "font-picker-react";
import uuid from "uuid";
import Swal from "sweetalert2";

// Our default state settings
let state = {
  isAuthenticating: true,
  loading: false,
  proStatus: false,
  toastList: [],
  toastName: "My Toast 1",
  toastId: "",
  toastEnabled: true,
  toastLocation: "All pages",
  toastLocationUrl: "",
  toastLocationCondition: "Exact match",
  toastTextColour: "#FFF",
  toastTextColourOpacity: 100,
  toastBackgroundColour: "#7FBCE9",
  toastBackgroundColourOpacity: 100,
  toastPreset: "blue",
  toastPosition: "bottom_left",
  toastAppearDelay: 5,
  toastDisappearDelay: 5,
  toastDisableDisappearTimer: false,
  toastDisableClose: false,
  toastDisableMobile: false,
  toastPriority: 1,
  toastDisableShadow: false,
  toastText: "This is your toast! Edit it below.",
  toastLink: "",
  toastLinkNewTab: false,
  toastFont: "Montserrat",
  toastFontWeight: 400,
  toastFontSize: 14,
  toastPremiumBackground: "",
  hideRating: false,
};

// Our default toast settings we use for new toasts
let baseToast = {
  toastName: "Your New Toast",
  toastEnabled: true,
  toastLocation: "All pages",
  toastLocationUrl: "",
  toastLocationCondition: "Exact match",
  toastTextColour: "#FFF",
  toastTextColourOpacity: 100,
  toastBackgroundColour: "#7FBCE9",
  toastBackgroundColourOpacity: 100,
  toastPreset: "blue",
  toastPosition: "bottom_left",
  toastAppearDelay: 5,
  toastDisappearDelay: 5,
  toastDisableDisappearTimer: false,
  toastDisableClose: false,
  toastDisableMobile: false,
  toastPriority: 1,
  toastDisableShadow: false,
  toastText: "This is your toast! Edit it below.",
  toastLink: "",
  toastLinkNewTab: false,
  toastFont: "Montserrat",
  toastFontWeight: 400,
  toastFontSize: 14,
  toastPremiumBackground: "",
};

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = state;
  }

  // When the component first loads
  componentDidMount() {
    const { isAuthenticating, hideRating } = this.state;
    if (isAuthenticating) {
      API.get("api", "/status" + window.location.search)
        .then((response) => {
          this.setState({ isAuthenticating: false }); // Otherwise finish authenticating and render the screen
          if (response) {
            // If we got back a response an active charge ID is on record
            this.setState({ proStatus: true });
          }
          this.loadToasts();
        })
        .catch((error) => {
          console.log(error.response); // Otherwise log the error, if any
        });
    }

    if (!hideRating) {
      //  If hideRating is not set to true, check if they're elligible for a review prompt
      API.get("api", "/review" + window.location.search)
        .then((response) => {
          if (response) {
            // If we got back a response they're elligble to get the review prompt
            this.reviewPrompt(response); // prompt them for a review
          }
        })
        .catch((error) => {
          console.log(error.response); // Otherwise log the error, if any
        });
    }
  }

  // Prompts the user for a review
  reviewPrompt(reviewUrl) {
    Swal({
      toast: true,
      position: "bottom-start",
      type: "question",
      title: "Do you find our app helpful?",
      confirmButtonText: "Yes!",
      showCancelButton: true,
      cancelButtonText: "Not really",
      customContainerClass: "review-swal",
    }).then((result) => {
      API.post("api", "/dismiss" + window.location.search, {
        // Make a note in the db to not show the review prompt again (timestamp of dismiss)
        body: {},
      });
      this.setState({ hideRating: true }); // Disable the review hook so we stop on annoying them.
      if (result.value) {
        // If they said yes show the review prompt
        Swal({
          toast: true,
          position: "bottom-start",
          type: "succcess",
          title:
            "We would really appreciate it if you helped our small New Zealand business by rating this app.",
          confirmButtonText: "Sure!",
          showCancelButton: true,
          cancelButtonText: "No thanks",
          customContainerClass: "review-swal",
        }).then((result) => {
          if (result.value) {
            window.open(reviewUrl, "_blank");
          }
        });
      } else {
        // Otherwise give them our condolences
        Swal({
          toast: true,
          position: "bottom-start",
          type: "info",
          title:
            "We are sorry to hear that, please feel free to get in touch with us if we can do anything to help.",
          confirmButtonText: "Okay",
          customContainerClass: "review-swal",
        });
      }
    });
  }

  // When the component unloads (page switch)
  componentWillUnmount() {
    state = this.state; // Remember our state for the next mount
    state.loading = false; // Explicitly set the loading state to false
    state.isAuthenticating = true; // Explicitly set the auth state to true
    state.proStatus = false; // Explicitly set the proStatus state to false
    state.toastId = ""; // Reset the toastId
  }

  // Render the homepage
  render() {
    const loadingMarkup = this.state.loading && <></>;
    const primaryAction = {
      content: this.state.proStatus ? "View Plans" : "Go Pro",
      onAction: () => {
        this.changePage("/pro");
      },
    };
    const secondaryActions = [
      {
        content: "Home",
        onAction: () => {
          this.changePage("/");
        },
      },
      {
        content: "FAQ",
        onAction: () => {
          this.changePage("/faq");
        },
      },
      {
        content: "Privacy Policy",
        onAction: () => {
          this.changePage("/terms");
        },
      },
    ];

    if (this.state.isAuthenticating) {
      // If the page hasn't loaded yet, show a placeholder spinner instead
      return (
        <Page
          title="Home"
          primaryAction={primaryAction}
          secondaryActions={secondaryActions}
        >
          <Banner status="critical">
            <TextStyle variation="strong">
              After much consideration, we have decided to sunset the app on the
              5th of October 2024. This app will cease to function on this date.
              We are currently creating a new app that will replace this one.
              And we will notify you once it is available. We apologize for any
              inconvenience this may cause.
            </TextStyle>
          </Banner>
          <div
            style={{
              paddingTop: 20,
            }}
          ></div>
          <Layout>
            <Layout.Section>
              <Stack alignment="center" distribution="center">
                <Spinner size="large" color="teal" />
              </Stack>
            </Layout.Section>
          </Layout>
        </Page>
      );
    }

    return (
      !this.state.isAuthenticating && (
        <Page
          title="Home"
          primaryAction={primaryAction}
          secondaryActions={secondaryActions}
        >
          <Banner status="critical">
            <TextStyle variation="strong">
              After much consideration, we have decided to sunset the app on the
              5th of October 2024. This app will cease to function on this date.
              We are currently creating a new app that will replace this one.
              And we will notify you once it is available. We apologize for any
              inconvenience this may cause.
            </TextStyle>
          </Banner>
          <div
            style={{
              paddingTop: 20,
            }}
          ></div>
          {loadingMarkup}
          <Layout>
            <Layout.Section secondary>{this.renderCard()}</Layout.Section>
            <Layout.Section secondary>
              <Card>
                <Card.Section>
                  <Stack alignment="center" distribution="equalSpacing">
                    <Heading>
                      Your Toasts (
                      {this.state.toastList ? this.state.toastList.length : "0"}
                      /{this.state.proStatus ? "25" : "1"})
                    </Heading>
                    <Button primary onClick={this.createToast}>
                      Create a New Toast
                    </Button>
                  </Stack>
                </Card.Section>
                {this.renderList()}
                {!this.state.proStatus && (
                  <Card.Section>
                    <Stack alignment="center" distribution="equalSpacing">
                      <Stack alignment="leading" vertical>
                        <Heading>3 reasons to go pro:</Heading>
                        <List type="bullet">
                          <List.Item>Manage up to 25 toasts</List.Item>
                          <List.Item>Target products & custom pages</List.Item>
                          <List.Item>
                            Access to special pro-only presets
                          </List.Item>
                        </List>
                      </Stack>
                      <Button
                        primary
                        onClick={() => {
                          this.changePage("/pro");
                        }}
                      >
                        Learn More
                      </Button>
                    </Stack>
                  </Card.Section>
                )}
                <Card.Section>
                  <Stack alignment="center" distribution="equalSpacing">
                    <Heading>
                      Feeling stuck? Check out our FAQ for answers to our
                      frequent questions, or send a message through our live
                      chat and we will respond as soon as we can.
                    </Heading>
                    <Button
                      onClick={() => {
                        this.changePage("/faq");
                      }}
                    >
                      Visit FAQ
                    </Button>
                  </Stack>
                </Card.Section>
              </Card>
            </Layout.Section>
          </Layout>
        </Page>
      )
    );
  }

  // Render's the toast setting controls on the left side, or a placeholder if no toast is active
  renderCard = () => {
    if (this.state.toastId)
      return (
        <Card>
          <Card.Section>
            <Stack alignment="center" distribution="equalSpacing">
              <Heading>Editing {this.state.toastName}</Heading>
              <Stack alignment="center" distribution="equalSpacing">
                <Button
                  primary={!this.state.toastEnabled}
                  onClick={this.toggleToast}
                >
                  {this.state.toastEnabled ? "Disable" : "Enable"}
                </Button>
                <Button primary onClick={this.saveToast}>
                  Save
                </Button>
              </Stack>
            </Stack>
          </Card.Section>
          <Card.Section>
            <Stack alignment="fill" distribution="center" vertical>
              <TextField
                label="Toast name"
                value={this.state.toastName}
                onChange={this.valueUpdater("toastName")}
                maxLength={30}
                helpText="Your toast name will only appear here on the app admin."
              />
              <ChoiceList
                title={"Where do you want your toast to appear?"}
                choices={[
                  { label: "All pages", value: "All pages" },
                  { label: "Homepage only", value: "Homepage only" },
                  {
                    label: "Everywhere but the homepage",
                    value: "Everywhere but the homepage",
                  },
                  { label: "All products (Pro)", value: "All products" },
                  {
                    label: "Custom URL (Pro)",
                    value: "custom_url",
                    renderChildren: (isSelected) => {
                      return (
                        isSelected && (
                          <Stack distribution="fill" vertical>
                            <Stack alignment="center" distribution="fill">
                              <Select
                                options={[
                                  {
                                    label: "Exact match",
                                    value: "Exact match",
                                  },
                                  {
                                    label: "Starts with",
                                    value: "Starts with",
                                  },
                                  { label: "Ends with", value: "Ends with" },
                                  { label: "Contains", value: "Contains" },
                                  {
                                    label: "Does not contain",
                                    value: "Does not contain",
                                  },
                                  {
                                    label: "Regex match",
                                    value: "Regex match",
                                  },
                                ]}
                                onChange={this.valueUpdater(
                                  "toastLocationCondition"
                                )}
                                value={this.state.toastLocationCondition}
                              />
                              <TextField
                                label="Your URL"
                                labelHidden
                                placeholder="/products/your-product-name"
                                onChange={this.valueUpdater("toastLocationUrl")}
                                value={this.state.toastLocationUrl}
                              />
                            </Stack>
                            <i>
                              Do not use the full URL, match everything after
                              your website name, e.g.
                              "/products/your-product-name"
                            </i>
                          </Stack>
                        )
                      );
                    },
                  },
                ]}
                selected={this.state.toastLocation}
                onChange={this.valueUpdater("toastLocation")}
              />
            </Stack>
          </Card.Section>
          <Card.Section>
            <Stack alignment="fill" distribution="center" vertical>
              <Stack alignment="trailing" distribution="fill">
                <Select
                  options={[
                    { label: "Clean Blue", value: "blue" },
                    { label: "Important Message", value: "important" },
                    { label: "High Contrast", value: "contrast" },
                    { label: "Relaxed Coffee", value: "coffee" },
                    { label: "Blue Sky", value: "sky" },
                    { label: "Lime Green", value: "lime" },
                    { label: "Summer Beach", value: "beach" },
                    { label: "Paper Script", value: "paper" },
                    { label: "Black Carbon (Pro)", value: "carbon" },
                    { label: "Pink Salmon (Pro)", value: "salmon" },
                    { label: "Yellow Yolk (Pro)", value: "yolk" },
                    { label: "Calm Cloud (Pro)", value: "cloud" },
                    { label: "Purple Sky (Pro)", value: "purple" },
                    { label: "Kiwifruit Blues (Pro)", value: "kiwifruit" },
                    { label: "Cotton Candy (Pro)", value: "pastel" },
                    { label: "Red Sunrise (Pro)", value: "sunrise" },
                    { label: "Morning Ocean (Pro)", value: "ocean" },
                    { label: "Jungle Jade (Pro)", value: "jade" },
                  ]}
                  onChange={this.changePreset}
                  value={this.state.toastPreset}
                  label="Preset"
                />
                <Button onClick={this.resetPreset}>Reset</Button>
              </Stack>
              <TextField
                label="Message"
                value={this.state.toastText}
                onChange={this.valueUpdater("toastText")}
                maxLength={100}
                helpText="Max length: 100 characters"
              />
              <TextField
                label="Link"
                value={this.state.toastLink}
                onChange={this.valueUpdater("toastLink")}
                type="url"
                placeholder="https://example.com"
                helpText="Leave empty to not link your toast"
              />
              <Checkbox
                checked={this.state.toastLinkNewTab}
                label="Open the link in a new tab"
                onChange={this.valueUpdater("toastLinkNewTab")}
              />
            </Stack>
          </Card.Section>
          <Card.Section>
            {this.state.toastPremiumBackground && (
              <Stack alignment="center" distribution="trailing">
                <Badge status="warning">
                  <TextStyle variation="strong">Pro</TextStyle>
                </Badge>
              </Stack>
            )}
            <Stack distribution="center">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "150px",
                  maxHeight: "150px",
                }}
              >
                <div
                  className={this.state.toastPremiumBackground}
                  style={{
                    display: "inline-block",
                    backgroundColor: this.getRgba(),
                    color: this.state.toastTextColour,
                    minWidth: "250px",
                    maxWidth: "300px",
                    textAlign: "center",
                    borderRadius: "2px",
                    padding: "16px",
                    position: "relative",
                    WebkitBoxShadow: this.state.toastDisableShadow
                      ? ""
                      : "0 3px 6px 0 rgba(0,0,0,.16)",
                    boxShadow: this.state.toastDisableShadow
                      ? ""
                      : "0 3px 6px 0 rgba(0,0,0,.16)",
                  }}
                >
                  <span
                    className="apply-font"
                    style={{
                      opacity: this.state.toastTextColourOpacity / 100,
                      fontSize:
                        (this.isValidFontSize()
                          ? this.state.toastFontSize
                          : 14) + "px",
                      fontWeight: this.state.toastFontWeight,
                      padding: "5px",
                      display: "inline-block",
                      lineHeight: "initial",
                      letterSpacing: "initial",
                    }}
                  >
                    {this.state.toastText}
                  </span>
                  <span
                    style={{
                      position: "absolute",
                      content: " ",
                      height: "10px",
                      width: "2px",
                      backgroundColor: this.state.toastTextColour,
                      transform: "rotate(45deg)",
                      right: "10px",
                      top: "6px",
                      display: this.state.toastDisableClose
                        ? "none"
                        : "inherit",
                    }}
                  ></span>
                  <span
                    style={{
                      position: "absolute",
                      content: " ",
                      height: "10px",
                      width: "2px",
                      backgroundColor: this.state.toastTextColour,
                      transform: "rotate(-45deg)",
                      right: "10px",
                      top: "6px",
                      display: this.state.toastDisableClose
                        ? "none"
                        : "inherit",
                    }}
                  ></span>
                </div>
              </div>
            </Stack>
          </Card.Section>
          <Card.Section title="Appearance">
            <Stack alignment="fill" distribution="center" vertical>
              <Stack alignment="center" distribution="fill">
                <TextField
                  label="Text Color"
                  onChange={this.valueUpdater("toastTextColour")}
                  value={this.state.toastTextColour}
                  placeholder="#FFFFFF"
                  connectedRight={
                    <TextField
                      onChange={this.valueUpdater("toastTextColourOpacity")}
                      value={this.state.toastTextColourOpacity}
                      suffix="%"
                      placeholder="100"
                      type="number"
                      min={0}
                      max={100}
                      connectedRight={
                        <ColorPicker
                          animation="slide-up"
                          color={this.state.toastTextColour}
                          alpha={+this.state.toastTextColourOpacity}
                          onChange={this.updateTextColour}
                        />
                      }
                    />
                  }
                />
                {!this.state.toastPremiumBackground && (
                  <TextField
                    label="Background Color"
                    onChange={this.valueUpdater("toastBackgroundColour")}
                    value={this.state.toastBackgroundColour}
                    placeholder="#FFFFFF"
                    connectedRight={
                      <TextField
                        onChange={this.valueUpdater(
                          "toastBackgroundColourOpacity"
                        )}
                        value={this.state.toastBackgroundColourOpacity}
                        suffix="%"
                        placeholder="100"
                        type="number"
                        min={0}
                        max={100}
                        connectedRight={
                          <ColorPicker
                            animation="slide-up"
                            color={this.state.toastBackgroundColour}
                            alpha={+this.state.toastBackgroundColourOpacity}
                            onChange={this.updateBackgroundColour}
                          />
                        }
                      />
                    }
                  />
                )}
              </Stack>
              <Stack alignment="trailing" distribution="equalSpacing">
                <Stack
                  alignment="fill"
                  distribution="center"
                  spacing="extraTight"
                  vertical
                >
                  <p>Font</p>
                  <FontPicker
                    apiKey="AIzaSyBKVB9LAxNB0AuwNLG0ussVUyXPtfteCCw"
                    activeFont={this.state.toastFont}
                    onChange={(nextFont) =>
                      this.setState({ toastFont: nextFont.family })
                    }
                  />
                </Stack>
                <Select
                  options={[
                    { label: "Light", value: 200 },
                    { label: "Normal", value: 400 },
                    { label: "Medium", value: 500 },
                    { label: "Bold", value: 600 },
                    { label: "Heavy", value: 900 },
                  ]}
                  onChange={this.valueUpdater("toastFontWeight")}
                  value={+this.state.toastFontWeight}
                  label="Font Weight"
                />
                <TextField
                  label="Font Size"
                  type="number"
                  min={8}
                  max={28}
                  suffix="pixels"
                  onChange={this.valueUpdater("toastFontSize")}
                  value={this.state.toastFontSize}
                  error={
                    this.isValidFontSize()
                      ? false
                      : "Font size must be between 8 to 28 pixels"
                  }
                />
              </Stack>
              <Stack alignment="trailing" distribution="equalSpacing">
                <p>
                  <i>
                    The selected font weight will match the closest font weight
                    available.
                  </i>
                </p>
              </Stack>
            </Stack>
          </Card.Section>
          <Card.Section title="Advanced">
            <Stack alignment="fill" distribution="center" vertical>
              <Stack alignment="center" distribution="fill">
                <Select
                  options={[
                    { label: "Top middle", value: "top_middle" },
                    { label: "Top left", value: "top_left" },
                    { label: "Top right", value: "top_right" },
                    { label: "Bottom middle", value: "bottom_middle" },
                    { label: "Bottom left", value: "bottom_left" },
                    { label: "Bottom right", value: "bottom_right" },
                  ]}
                  onChange={this.valueUpdater("toastPosition")}
                  value={this.state.toastPosition}
                  label="Position"
                />
                <TextField
                  label="Priority"
                  type="number"
                  onChange={this.valueUpdater("toastPriority")}
                  value={this.state.toastPriority}
                />
              </Stack>
              <Stack alignment="center" distribution="fillEvenly">
                <TextField
                  label="Appear Delay"
                  type="number"
                  min={0}
                  max={3600}
                  suffix="seconds"
                  onChange={this.valueUpdater("toastAppearDelay")}
                  value={this.state.toastAppearDelay}
                />
                <TextField
                  label="Disappear Delay"
                  type="number"
                  min={0}
                  max={3600}
                  suffix="seconds"
                  onChange={this.valueUpdater("toastDisappearDelay")}
                  value={this.state.toastDisappearDelay}
                />
              </Stack>
              <Stack alignment="center" distribution="fillEvenly">
                <Checkbox
                  checked={this.state.toastDisableDisappearTimer}
                  label="Disable disappear timer"
                  onChange={this.valueUpdater("toastDisableDisappearTimer")}
                />
                <Checkbox
                  checked={this.state.toastDisableClose}
                  label="Disable close button"
                  onChange={this.valueUpdater("toastDisableClose")}
                />
                <Checkbox
                  checked={this.state.toastDisableShadow}
                  label="Disable shadow"
                  onChange={this.valueUpdater("toastDisableShadow")}
                />
                <Checkbox
                  checked={this.state.toastDisableMobile}
                  label="Disable on mobile devices"
                  onChange={this.valueUpdater("toastDisableMobile")}
                />
              </Stack>
            </Stack>
          </Card.Section>
          <Card.Section>
            <Stack alignment="fill" distribution="fill" vertical>
              <Button primary fullWidth onClick={this.saveToast}>
                Save Toast
              </Button>
              <Button primary fullWidth onClick={this.cloneToast}>
                Copy to New Toast
              </Button>
              <Button destructive fullWidth onClick={this.deleteToast}>
                Delete Toast
              </Button>
            </Stack>
          </Card.Section>
        </Card>
      );
    else
      return (
        <Card>
          <Card.Section>
            <Stack alignment="center" distribution="equalSpacing">
              <Heading>Select or create a toast</Heading>
              <Stack alignment="center" distribution="equalSpacing">
                <Button primary onClick={this.createToast}>
                  Create a New Toast
                </Button>
              </Stack>
            </Stack>
          </Card.Section>
        </Card>
      );
  };

  // Render the list of toasts
  renderList = () => {
    if (this.state.toastList && this.state.toastList.length)
      return (
        <Card.Section>
          <ResourceList
            resourceName={{ singular: "toast", plural: "toasts" }}
            items={this.state.toastList}
            renderItem={(item) => {
              const {
                toastId,
                toastEnabled,
                toastName,
                toastLocation,
                toastLocationUrl,
                toastLocationCondition,
              } = item;

              return (
                <ResourceList.Item
                  id={toastId}
                  onClick={this.changeToast}
                  accessibilityLabel={`View details for ${toastName}`}
                >
                  <h3>
                    <TextStyle variation="strong">
                      {toastName}{" "}
                      <Badge status={toastEnabled ? "success" : "warning"}>
                        {toastEnabled ? "enabled" : "disabled"}
                      </Badge>
                    </TextStyle>
                  </h3>
                  <div>
                    {toastLocation + "" !== "custom_url"
                      ? toastLocation
                      : toastLocationCondition + ": " + toastLocationUrl}
                  </div>
                </ResourceList.Item>
              );
            }}
          />
        </Card.Section>
      );
  };

  // Change our page, but only if our current page is done loading to prevent memory leaks
  changePage = (url, keepParams = true) => {
    const { isAuthenticating } = this.state;
    if (!isAuthenticating) {
      this.props.history.push(url + (keepParams ? window.location.search : ""));
    }
  };

  // Create a new toast
  createToast = () => {
    if (
      !this.state.toastList.length ||
      (this.state.toastList.length < 25 && this.state.proStatus)
    ) {
      let newToastId = uuid.v1();
      let newToast = { ...baseToast, toastId: newToastId };
      let newToastList = this.state.toastList.slice();
      newToastList.push(newToast);
      this.setState(() => {
        return newToast; // Set all matching state variables to that of the new toast
      });
      this.setState({ toastList: newToastList, loading: true }, () => {
        this.saveToasts();
      });
    } else {
      Swal({
        title: "You've exceeded your limit",
        text: "You can only manage 1 toast on the free plan, on the pro plan you're able to manage up to 25 toasts. To learn more about upgrading to the pro-plan click the button below.",
        type: "warning",
        showCancelButton: true,
        width: 600,
        backdrop: "rgba(0,0,0,0)",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Learn More",
        cancelButtonText: "No thanks",
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.changePage("/pro"); // Go to the pro page if they press the learn more button
        }
      });
    }
  };

  // Change the active toast
  changeToast = (toast) => {
    let newToast = this.state.toastList.find((obj) => obj.toastId === toast);
    this.setState(() => {
      return newToast; // Set all matching state variables to that of the new toast
    });
  };

  // Saves the active toast
  saveToast = () => {
    let activeToast = this.state.toastList.find(
      (obj) => obj.toastId === this.state.toastId
    );
    let newToast = Object.keys(activeToast).reduce(
      (a, key) => ({ ...a, [key]: this.state[key] }),
      {}
    );
    newToast.toastName = newToast.toastName
      ? newToast.toastName
      : "Your New Toast";
    const isExternalUrl = new RegExp(
      "^(http://www.|https://www.|http://|https://)?[a-zA-Z0-9]+([-.]{1}[a-zA-Z0-9]+)*[.][a-zA-Z]{2,5}(:[0-9]{1,5})?(/.*)?$"
    );
    const hasHttps = new RegExp("^(http://|https://)");
    newToast.toastLink = isExternalUrl.test(newToast.toastLink)
      ? hasHttps.test(newToast.toastLink)
        ? newToast.toastLink
        : "//" + newToast.toastLink
      : newToast.toastLink;
    // If we're trying to use a pro-feature when we're not on the pro plan show the pro-only popup
    if (
      !this.state.proStatus &&
      (newToast.toastPremiumBackground ||
        newToast.toastLocation + "" === "custom_url" ||
        newToast.toastLocation + "" === "All products")
    ) {
      newToast.toastEnabled = false;
      this.setState({ toastEnabled: false });
      Swal({
        title: "You've used a pro-only feature",
        text: "Pro features include targeting products & custom pages, as well as special pro-only presets. We've saved your toast but it is currently disabled, if you'd like to keep the pro-only settings learn more about the pro plan below, or you can resave the toast with the options available on the free plan to enable your toast.",
        type: "warning",
        showCancelButton: true,
        width: 600,
        backdrop: "rgba(0,0,0,0)",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Learn More",
        cancelButtonText: "Leave as-is",
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.changePage("/pro"); // Go to the pro page if they press the learn more button
        }
      });
    } else {
      // Otherwise just show a save toast
      Swal({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        type: "success",
        title: "Changes saved",
        customContainerClass: "small-swal",
      });
    }
    let newToastList = this.state.toastList.slice();
    let toastIndex = newToastList.findIndex(
      (x) => x.toastId === newToast.toastId
    );
    newToastList[toastIndex] = newToast;
    this.setState(
      { toastList: newToastList, toastName: newToast.toastName, loading: true },
      () => {
        this.saveToasts();
      }
    );
  };

  // Delete the active toast
  deleteToast = () => {
    Swal({
      title: "Are you sure?",
      text: "Deleting a toast is permanent, and it will not be able to be recovered.",
      type: "warning",
      showCancelButton: true,
      width: 600,
      backdrop: "rgba(0,0,0,0)",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Delete Toast",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        let newToastList = this.state.toastList.filter(
          (toast) => toast.toastId !== this.state.toastId
        );
        this.setState(
          { toastList: newToastList, toastId: "", loading: true },
          () => {
            this.saveToasts();
          }
        );
      }
    });
  };

  // Copy the active toast into a new toast
  cloneToast = () => {
    if (
      !this.state.toastList.length ||
      (this.state.toastList.length < 25 && this.state.proStatus)
    ) {
      let newToastId = uuid.v1();
      let activeToast = this.state.toastList.find(
        (obj) => obj.toastId === this.state.toastId
      );
      let newToast = Object.keys(activeToast).reduce(
        (a, key) => ({ ...a, [key]: this.state[key] }),
        {}
      );
      newToast.toastId = newToastId;
      newToast.toastName = newToast.toastName + " (copy)";
      let newToastList = this.state.toastList.slice();
      newToastList.push(newToast);
      this.setState(() => {
        return newToast; // Set all matching state variables to that of the new toast
      });
      this.setState({ toastList: newToastList, loading: true }, () => {
        this.saveToasts();
      });
      Swal({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        type: "success",
        title: "Toast copied",
        customContainerClass: "small-swal",
      });
    } else {
      Swal({
        title: "You've exceeded your limit",
        text: "You can only manage 1 toast on the free plan, on the pro plan you're able to manage up to 25 toasts. To learn more about upgrading to the pro-plan click the button below.",
        type: "warning",
        showCancelButton: true,
        width: 600,
        backdrop: "rgba(0,0,0,0)",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Learn More",
        cancelButtonText: "No thanks",
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.changePage("/pro"); // Go to the pro page if they press the learn more button
        }
      });
    }
  };

  // Toggle the toast enable/disabled
  toggleToast = () => {
    this.setState(
      ({ toastEnabled }) => ({ toastEnabled: !toastEnabled, loading: true }),
      () => {
        this.saveToast();
      }
    ); // save the toast after enabling/disabling it
  };

  // Change the preset in use for the current toast
  changePreset = (preset) => {
    this.setState({ toastPreset: preset });
    this.setState(() => {
      return presets[preset]; // Set all matching state variables to that of the preset
    });
  };

  // Reset the appearance settings back to the preset defaults
  resetPreset = () => {
    this.setState(
      ({
        toastBackgroundColour,
        toastBackgroundColourOpacity,
        toastTextColour,
        toastTextColourOpacity,
        toastFont,
        toastFontSize,
        toastFontWeight,
      }) => {
        return presets[this.state.toastPreset];
      }
    );
  };

  // Get the RGBA value of a hex
  getRgba = () => {
    // Same hex-check as the function we call (HexRgb) for sanity's sake.
    const hexChars = "a-f\\d";
    const match3or4Hex = `#?[${hexChars}]{3}[${hexChars}]?`;
    const match6or8Hex = `#?[${hexChars}]{6}([${hexChars}]{2})?`;
    const nonHexChars = new RegExp(`[^#${hexChars}]`, "gi");
    const validHexSize = new RegExp(`^${match3or4Hex}$|^${match6or8Hex}$`, "i");

    if (
      typeof this.state.toastBackgroundColour !== "string" ||
      nonHexChars.test(this.state.toastBackgroundColour) ||
      !validHexSize.test(this.state.toastBackgroundColour)
    ) {
      return this.state.toastBackgroundColour;
    } else {
      const rgb = HexRgb(this.state.toastBackgroundColour, { format: "array" });
      return (
        "rgba(" +
        rgb[0] +
        "," +
        rgb[1] +
        "," +
        rgb[2] +
        "," +
        this.state.toastBackgroundColourOpacity / 100 +
        ")"
      );
    }
  };

  // Update the color of the toast text using the color picker
  updateTextColour = (colours) => {
    this.setState(({ toastTextColour, toastTextColourOpacity }) => {
      return {
        toastTextColour: colours.color,
        toastTextColourOpacity: colours.alpha,
      };
    });
  };

  // Update the color of the toast background using the color picker
  updateBackgroundColour = (colours) => {
    this.setState(({ toastBackgroundColour, toastBackgroundColourOpacity }) => {
      return {
        toastBackgroundColour: colours.color,
        toastBackgroundColourOpacity: colours.alpha,
      };
    });
  };

  // Check the the font size is valid before rendering, and resize if not.
  isValidFontSize = () => {
    return this.state.toastFontSize <= 28 && this.state.toastFontSize >= 8;
  };

  // Save the toasts to the db
  saveToasts = () => {
    API.post("api", "/save" + window.location.search, {
      body: {
        toastList: JSON.stringify(this.state.toastList),
      },
    })
      .then((response) => {
        this.setState({ loading: false }); // stop showing the loading animation
      })
      .catch((error) => {
        console.log(error.response); // Otherwise log the error, if any
      });
  };

  // Load the settings from our db into our two fields
  loadToasts = () => {
    API.get("api", "/load" + window.location.search)
      .then((response) => {
        let newToastList = this.state.proStatus
          ? JSON.parse(response.toastList)
          : JSON.parse(response.toastList).slice(0, 1); // If we're on the free plan we only want to be returning 1 toast
        // If we're not on the pro plan and the toast we loaded uses pro features, make sure it's disabled before loading it in
        if (
          !this.state.proStatus &&
          (newToastList[0].toastPremiumBackground ||
            newToastList[0].toastLocation + "" === "custom_url" ||
            newToastList[0].toastLocation + "" === "All products")
        ) {
          newToastList[0].toastEnabled = false;
        }
        this.setState({ toastList: newToastList }); // Set our toastlist to the loaded toasts
      })
      .catch((error) => {
        console.log(error.response); // Otherwise log the error, if any
      });
  };

  // Standard state changing function
  valueUpdater(field) {
    return (value) => this.setState({ [field]: value });
  }
}

export default Home;
